'use client';

import { memo } from 'react';
import { TableCell, TableHead, TableRow, Box } from '@mui/material';
import { ArrowUpward, ArrowDownward } from '@mui/icons-material';
import { useTranslation } from '@/kit/useTranslation';

/**
 * Sortable table header with clickable columns
 */
const SortableTableHeader = memo(({ columns, sortField, sortDirection, onSort }) => {
  const { t } = useTranslation();
  return (
    <TableHead>
      <TableRow sx={{ bgcolor: '#f9fafb' }}>
        {columns.map((col) => (
          <TableCell
            key={col.field}
            align={col.align || 'left'}
            sx={{
              fontWeight: 700,
              color: '#374151',
              fontSize: '0.8rem',
              py: 1.5,
              cursor: col.sortable !== false ? 'pointer' : 'default',
              userSelect: 'none',
              '&:hover': col.sortable !== false ? { bgcolor: '#f3f4f6' } : {},
            }}
            onClick={() => col.sortable !== false && onSort(col.field)}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              {col.label}
              {col.sortable !== false && sortField === col.field && (
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  {sortDirection === 'asc' ? (
                    <ArrowUpward sx={{ fontSize: 14, color: '#6366f1' }} />
                  ) : (
                    <ArrowDownward sx={{ fontSize: 14, color: '#6366f1' }} />
                  )}
                </Box>
              )}
            </Box>
          </TableCell>
        ))}
        <TableCell
          align="center"
          sx={{
            fontWeight: 700,
            color: '#374151',
            fontSize: '0.8rem',
            py: 1.5,
            width: 100,
          }}
        >
          {t('common.actions')}
        </TableCell>
      </TableRow>
    </TableHead>
  );
});

SortableTableHeader.displayName = 'SortableTableHeader';

export default SortableTableHeader;
